/**
 * Lock the Forge shell to the CMMD organization from the embed handoff.
 *
 * Uses the existing `currentForgeWorkspaceId` standard (forge#3572) and pins
 * the command-center workspace filter so the iframe cannot wander to another
 * org while `?embed=1` is set.
 */

import { writeStoredWorkspaceFilter } from "../components/command-center/workspaceFilterStorage";
import { seedCurrentForgeWorkspaceId } from "../workspace/currentForgeWorkspaceStore";

const SESSION_FLAG_KEY = "cmmd-forge-embed-session";
const SESSION_ORG_KEY = "cmmd-forge-embed-organization-id";

export function alreadyHasEmbedSession(): boolean {
  try {
    return sessionStorage.getItem(SESSION_FLAG_KEY) === "1";
  } catch {
    return false;
  }
}

function markEmbedSession(): void {
  try {
    sessionStorage.setItem(SESSION_FLAG_KEY, "1");
  } catch {
    // Private mode may block sessionStorage; exchange cookies still apply.
  }
}

export function readStoredEmbedOrganizationId(): number | null {
  try {
    const raw = sessionStorage.getItem(SESSION_ORG_KEY);
    if (raw === null || !/^\d+$/.test(raw)) return null;
    const parsed = Number.parseInt(raw, 10);
    return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : null;
  } catch {
    return null;
  }
}

function writeStoredEmbedOrganizationId(organizationId: number): void {
  try {
    sessionStorage.setItem(SESSION_ORG_KEY, String(organizationId));
  } catch {
    // Same private-mode allowance as the session flag.
  }
}

/** Seed + pin filter + remember org for embed session resume. */
export function bindEmbedForgeWorkspaceId(organizationId: number): void {
  seedCurrentForgeWorkspaceId(organizationId);
  writeStoredWorkspaceFilter(String(organizationId));
  writeStoredEmbedOrganizationId(organizationId);
  markEmbedSession();
}
